import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { handleResponseError } from './Helper';

export const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SERVER_BASE_ADDRESS,
});
console.log('API Base URL:', import.meta.env.VITE_SERVER_BASE_ADDRESS);

// Attach authentication token to all requests
const attachAccessToken = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

axiosInstance.interceptors.request.use(
  async config => attachAccessToken(config),
  error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response => {
    // Check for refreshed token in header
    const newToken = response.headers['x-auth-token'];
    if (newToken) {
      localStorage.setItem('auth_token', newToken);
    }
    return response;
  },
  async (error: AxiosError) => {
    return handleResponseError(error);
  }
);
